import { Select } from "antd";
import useForm from "../../../hooks/useForm";
import { CloseModal } from "../../../hooks/useModal";
import usePageState from "../../../hooks/usePageState";
import AppInputNumber from "../../../components/AppInputNumber";
import BaseDialog from "../../../components/BaseDialog";
import Column from "../../../components/Column";
import DialogFooter from "../../../components/DialogFooter";
import {
  SALE_VALUE_TYPE_ENUM,
  SALE_VALUE_TYPE_OPTION,
  YES_NO_DATA,
  YES_NO_ENUM,
} from "../../../../applications/constants/AppConst";
import * as Yup from "yup";
import AppInputDate from "../../../components/AppInputDate";
import {
  CreateVoucherRequest,
  VoucherResponse,
} from "../../../../infrastructure/model/VoucherModel";
import AppInputDropdown from "../../../components/AppInputDropdown";
import { createVoucherUseCase } from "../../../../applications/useCase/ApiUseCase/VoucherApiUseCase";

interface CreateVoucherProps {
  onClose: CloseModal;
  updateItem?: VoucherResponse;
}

function CreateVoucherDialog(props: CreateVoucherProps) {
  const { onClose, updateItem } = props;
  const { showClientError, showError, setLoading, isLoading, showSuccess } = usePageState();

  async function insertItem(request: CreateVoucherRequest) {
    const res = await createVoucherUseCase({
      request,
      setLoading,
      showError,
      showSuccess,
    });

    if (res) {
      onClose(res);
    }
  }

  const validationSchema = Yup.object({
    // code: Yup.string().required("Thiếu mã voucher"),
    start_date: Yup.date()
      .transform((value, originalValue) =>
        typeof originalValue === "number" ? new Date(originalValue) : value
      )
      .required("Ngày bắt đầu là bắt buộc"),

    end_date: Yup.date()
      .transform((value, originalValue) =>
        typeof originalValue === "number" ? new Date(originalValue) : value
      )
      .min(Yup.ref("start_date"), "Ngày kết thúc phải sau ngày bắt đầu")
      .required("Vui lòng nhập ngày kết thúc"),
    discount_value: Yup.number().required("Giá trị discount phải lớn hơn 0"),
  });

  const formik = useForm<CreateVoucherRequest>({
    initialValues: updateItem?.id
      ? {
          ...updateItem,
        }
      : {
          applicable_user_count: 0,
          // code: "",
          discount_type: SALE_VALUE_TYPE_ENUM.VND,
          discount_value: 0,
          end_date: 0,
          is_active: false,
          start_date: 0,
        },
    validationSchema: validationSchema,
    onSubmit: async (values) => await insertItem(values),
  });

  const selectCurrencyAfter = (ignoreCoc?: boolean) => {
    const options = SALE_VALUE_TYPE_OPTION?.filter((_, i) => i !== 2);

    return (
      <Select
        defaultValue={
          formik.values.discount_type ? formik.values.discount_type : SALE_VALUE_TYPE_ENUM.VND
        }
        style={{ width: 80 }}
        onChange={(e) => formik.updateFieldValue("discount_type", e)}
      >
        {options?.map((s, index) => {
          return <Select.Option value={s.value}>{s.label}</Select.Option>;
        })}
      </Select>
    );
  };

  return (
    <BaseDialog
      title={updateItem?.id ? "Cập nhật voucher" : "Thêm mới voucher"}
      isLoading={isLoading}
      width={"50vw"}
      footer={
        <DialogFooter
          submitProps={{
            onClick: () => formik.checkErrorAndSubmit(showClientError),
          }}
          cancelProps={{
            onClick: () => onClose(),
          }}
        />
      }
    >
      <Column className="gap-2 w-100">
        {/* <AppInputText
          label="Mã voucher"
          currentValue={formik.values.code}
          isRequired
          onTextChange={(e) => formik.updateFieldValue("code", e)}
          errorText={formik.getFormErrorMessage("code")}
        /> */}
        <AppInputDropdown
          label="Trạng thái hoạt động"
          currentValue={formik.values.is_active ? YES_NO_ENUM.YES : YES_NO_ENUM.NO}
          isRequired
          options={YES_NO_DATA}
          onChangeValue={(e) => formik.updateFieldValue("is_active", e === YES_NO_ENUM.YES)}
          errorText={formik.getFormErrorMessage("is_active")}
        />
        <AppInputDate
          label="Ngày bắt đầu"
          currentValue={formik.values.start_date}
          isRequired
          isShowTime={false}
          onChangeValue={(e) => formik.updateFieldValue("start_date", e!)}
          errorText={formik.getFormErrorMessage("start_date")}
        />
        <AppInputDate
          label="Ngày kết thúc"
          currentValue={formik.values.end_date}
          isRequired
          isShowTime={false}
          onChangeValue={(e) => formik.updateFieldValue("end_date", e!)}
          errorText={formik.getFormErrorMessage("end_date")}
        />
        <AppInputNumber
          label="Số lượng user được áp dụng"
          className="flex-1 w-100"
          currentValue={formik.values.applicable_user_count}
          onChangeValue={(e) => formik.updateFieldValue("applicable_user_count", e)}
        />
        <AppInputNumber
          label="Giảm giá"
          className="flex-1 w-100"
          currentValue={formik.values.discount_value}
          onChangeValue={(e) => formik.updateFieldValue("discount_value", e)}
          min={0}
          errorText={formik.getFormErrorMessage("discount_value")}
          addonAfter={selectCurrencyAfter(true)}
        />
      </Column>
    </BaseDialog>
  );
}
export default CreateVoucherDialog;
